/** O cartão vivo do comando `/`: a mensagem guarda {tipo, ref}; o dado vem na hora. */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { cartao as pedirCartao } from "../../services/chat";

const COR_DO_ESTADO = { success: "var(--success-solid)", warning: "var(--warning-solid)", danger: "var(--danger-solid)", info: "var(--info-solid)", neutral: "var(--border-strong)" };

function formatarValor(valor, unidade) {
  const texto = typeof valor === "number" ? valor.toLocaleString("pt-BR", { maximumFractionDigits: 2 }) : valor;
  return unidade ? `${texto} ${unidade}` : texto;
}

/** O cartão vivo: a mensagem guarda {tipo, ref}; o dado é pedido na hora de desenhar. */
export function CartaoVivo({ cartao, request, versao }) {
  const [dado, setDado] = useState(null);
  const [erro, setErro] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    let vivo = true;
    pedirCartao(request, cartao.tipo, cartao.ref)
      .then((d) => vivo && (setDado(d), setErro(null)))
      .catch((e) => vivo && setErro(e?.status === 403 ? "seu cargo não abre esta tela" : (e?.payload?.detalhe || "não encontrado agora")));
    return () => { vivo = false; };
  }, [cartao.tipo, cartao.ref, request, versao]);
  if (!dado) {
    return (
      <div className={`pchat-cartao ${erro ? "indisponivel" : ""}`}>
        <div className="cab"><div><b>/{cartao.tipo} {cartao.ref}</b><span className="muted">{erro || "carregando…"}</span></div></div>
      </div>
    );
  }
  const linkErp = dado.link_erp || null;
  return (
    <div className="pchat-cartao" style={{ borderLeftColor: COR_DO_ESTADO[dado.estado || "info"] || COR_DO_ESTADO.info }}>
      <div className="cab">
        <div style={{ minWidth: 0 }}><b>{dado.titulo}</b>{dado.subtitulo && <span className="muted">{dado.subtitulo}</span>}</div>
        <span className="pchat-chip">ao vivo</span>
      </div>
      {dado.campos?.length > 0 && (
        <div className="campos">
          {dado.campos.map((f) => <div key={f.rotulo} className={f.destaque ? "destaque" : ""}><small>{f.rotulo}</small><b>{formatarValor(f.valor, f.unidade)}</b></div>)}
        </div>
      )}
      {dado.linhas?.length > 0 && (
        <div className="linhas">
          {dado.linhas.map((l, i) => (
            <div key={`${l.titulo}-${i}`}>
              <span className="t"><b>{l.titulo}</b>{l.detalhe && <small>{l.detalhe}</small>}</span>
              {l.valor !== undefined && l.valor !== "" && <span className="v">{formatarValor(l.valor, l.unidade)}</span>}
            </div>
          ))}
        </div>
      )}
      {linkErp ? (
        <button type="button" className="pchat-btn texto" style={{ justifySelf: "start" }} onClick={() => navigate(linkErp)}>Abrir no ERP</button>
      ) : dado.link_cut ? (
        <small className="muted">Dado do PharuCut</small>
      ) : null}
    </div>
  );
}
